import { render, staticRenderFns } from "./addWalletAddress.vue?vue&type=template&id=737ab5e2&scoped=true"
import script from "./addWalletAddress.vue?vue&type=script&lang=js"
export * from "./addWalletAddress.vue?vue&type=script&lang=js"
import style0 from "./addWalletAddress.vue?vue&type=style&index=0&id=737ab5e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737ab5e2",
  null
  
)

export default component.exports